import { usePermissions } from 'hooks';
import { KeycloakRole, Seletor } from 'roles';

type Props = {
  children: React.ReactNode;
  role?: KeycloakRole;
  seletor?: Seletor;
  customCondition?: boolean;
};

export const ProtectedComponent = ({
  children,
  role,
  seletor,
  customCondition = true
}: Props) => {
  const { hasPermission } = usePermissions();

  if (customCondition && hasPermission(role, seletor)) {
    return children;
  }

  return null;
};
